import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { GenericService } from '../../commons/generic.service';
import {HomeReponseDTO} from "../../model/homeResponse.dto";
import { UsuarioPerfilDTO } from "../../model/dadosServidorBensValores.dto";

@Injectable()
export class HomeService extends GenericService {
    private relativePath = 'api/v1/home/';

    constructor(http: HttpClient) {
        super(http);
    }

    getLotacaoeFoto(): Observable<HomeReponseDTO>{
        return this.getMethod(this.relativePath + 'servidor-dados-basicos');
    }

    getDadosServidor(): Observable<UsuarioPerfilDTO>{
        return this.getMethod('api/v1/info-servidor/bens-valores');
    }
}
